import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	setDocumentFilter, downloadDocument, findMeeting, switchMainTabDispatch,
	setMeetingFocus, setCurrentDocumentTopics
} from '../actions';

class DocumentTableRow extends Component {

	constructor( props ) {
		super( props );
		this.state = {
			show_document_details: [], show_description: []
		};
	}

	showDetails( documentID ) {
		let newState = this.state;
		newState.show_document_details = addOrRemoveFromArray( newState.show_document_details, documentID );
		this.setState( newState );
	}

	toggleDescription( documentID ) {
		let newState = this.state;
		newState.show_description = addOrRemoveFromArray( newState.show_description, documentID );
		this.setState( newState );
	}

	handleButtonDownload( file_name, download_file_name, ID, bucket_name ) {
		this.props.downloadDocument( file_name, download_file_name, ID, bucket_name );
	}

	getLoadingDocument() {
		return (<img src={getAjaxSpinner()}/>);
	}

	getDownloadButton( document ) {
		if ( this.props.generatingDocument.includes( document.file_name ) ) {
			return (
				<button className="text-button" type="button">{ this.getLoadingDocument() }</button>
			);
		} else {
			return (
				<button onClick={ this.handleButtonDownload.bind( this, document.file_name, document.download_file_name, document.ID, document.bucket_name ) } className="documents-download-document text-button" data-document-id={ document.ID } type="button">
					<span className="glyphicon glyphicon-download-alt documents-download-document" data-document-id={ document.ID } />
				</button>
			);
		}
	}

	/**
	 * @param meeting_id
	 */
	goToMeeting( meeting_id ) {
		let allMeetings = this.props.allMeetings;
		let focus_meeting = [];
		//filtering all upcoming meetings to see if focus meeting ID is in here.
		if ( typeof allMeetings.upcoming_meetings !== 'undefined' ) {
			focus_meeting = allMeetings.upcoming_meetings.filter( meeting => {
				return meeting.ID === parseInt( meeting_id );
			} );
		}
		//filtering all past meetings to see if focus meeting ID is in here.
		if ( typeof allMeetings.past_meetings !== 'undefined' && focus_meeting.length === 0 ) {
			focus_meeting = allMeetings.past_meetings.filter( meeting => {
				return meeting.ID === parseInt( meeting_id );
			} );
		}
		//If no meeting ID has been found in existing meetings, find the meeting seperately.
		if ( focus_meeting.length === 0 ) {
			this.props.findMeeting( meeting_id );
		} else {
			//If meeting was found, set it as the focus meeting
			this.props.setMeetingFocus( focus_meeting );
		}
		//Switch to meetings tab.
		this.props.switchMainTabDispatch( 'meetings' );
	}

	/**
	 *
	 * @param topic
	 */
	addTopic( topic ) {
		let currentTopics = this.props.currentDocumentTopics;
		if ( !currentTopics.includes( topic ) ) {
			currentTopics.push( topic );
		}
		// set the document filters with current topic and then set current topic.
		this.props.setDocumentFilter( 'tags', currentTopics );
		this.props.setCurrentDocumentTopics( topic );
	}

	/**
	 *
	 * @param document
	 * @returns {boolean}
	 */
	isDocumentWithMeeting( document ) {
		return (document.post_type === 'meeting'
		);
	}

	render() {
		const document = this.props.document;
		const committee = findCommittee( this.props.committees, document.ccode ).title;
		const type = this.isDocumentWithMeeting( document )
			? 'Meeting-Specific'
			: 'General';
		const showDetails = (this.state.show_document_details.includes( document.ID ) || this.props.expandAllDocuments
		);
		const chevronClass = (showDetails
		                     )
			? 'fa-solid fa-chevron-up'
			: 'fa-solid fa-chevron-down';
		let documentHtml;
		documentHtml = (<tr>
				<td className="documents-table-cell">
					{ this.getDownloadButton( document ) }
					{ document.download_file_name }
				</td>
				<td className="documents-table-cell">{ committee }</td>
				<td className="documents-table-cell">{ type }</td>
				<td className="documents-table-cell">{ document.category }</td>
				<td className="documents-table-cell">
					<div className="document-date-meeting-container">
					<div className="document-meeting-container">
					{ document.nice_date }

						{ this.isDocumentWithMeeting( document ) && (
							<button className="text-button" onClick={ this.goToMeeting.bind( this, document.meeting_id ) } type="button">View Meeting</button>
						) }
					</div>
					<i className={ chevronClass } onClick={ this.showDetails.bind( this, document.ID ) }/>
					</div>
				</td>
			</tr>
		);
		//for document details
		if ( showDetails ) {

			let tags_arr = [];
			if ( typeof document.tags !== 'undefined' ) {
				tags_arr = document.tags.map( ( topic, index ) => {
					return (<div className="tags-container">
							<button onClick={ this.addTopic.bind( this, topic ) } className="text-button" type="button">{ topic } </button>
							{ ((index + 1
							   ) !== document.tags.length
							  ) && ', ' }</div>
					);
				} );
			}
			documentHtml = [
				documentHtml, (<tr className="document-details-container">
						<td colspan={ 5 }>
							<div className="mobile-only document-extra-info">
								<div className="extra-info-container">
									<span><strong>Committee:</strong></span>{ committee }
								</div>
								<div className="extra-info-container">
									<span><strong>Type:</strong></span>{ type }
								</div>
								<div className="extra-info-container">
									<span><strong>Category:</strong></span>{ document.category }
								</div>
								<div className="extra-info-container">
									<span><strong>Date:</strong></span>{ document.nice_date }
								</div>
							</div>
							<div className="tags-section">
								{ tags_arr.length > 0 && <div>
									<span><strong>Tags:</strong></span>
									{ tags_arr }
								</div> }
								{ tags_arr.length <= 0 &&
								  <span><strong>No Tags Available</strong></span> }
							</div>
							{ this.state.show_description.includes( document.ID ) &&
							  <div>
								  <button className="text-button description-button" onClick={ this.toggleDescription.bind( this, document.ID ) } type="button">Hide Description</button>
								  <div className="description-container">{ document.description }</div>
							  </div> }
							{ !this.state.show_description.includes( document.ID ) &&
							  <button className="text-button description-button" onClick={ this.toggleDescription.bind( this, document.ID ) } type="button">View Description</button> }

						</td>
					</tr>
				)
			];
		}
		return documentHtml;

	}

}

function mapStateToProps( { allMeetings, committees, currentDocumentTopics, documentFilter, generatingDocument, expandAllDocuments } ) {
	return {
		allMeetings,
		committees,
		currentDocumentTopics,
		documentFilter,
		generatingDocument,
		expandAllDocuments
	};
}

export default connect( mapStateToProps, {
	setDocumentFilter,
	downloadDocument,
	findMeeting,
	switchMainTabDispatch,
	setMeetingFocus,
	setCurrentDocumentTopics
} )( DocumentTableRow );